import script from "./CreateGoals.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateGoals.vue?vue&type=script&setup=true&lang=js"

import "./CreateGoals.vue?vue&type=style&index=0&id=18cffa90&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18cffa90"]])

export default __exports__